export default "__VITE_ASSET__CEAaTdE2__"